import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import Documents from "components/OrderDetail/Documents";
import OrderStatus from "components/OrderDetail/OrderStatus";
import TrademarkClassifications from "components/OrderDetail/TrademarkClassifications";
import TrademarkOwners from "components/OrderDetail/TrademarkOwners";
import TrademarkRegisterDetails from "components/OrderDetail/Products/TrademarkRegisterDetails";

const Row = styled.div`
  display: flex;
  width: 1364px;

  @media (max-width: 1350px) {
    flex-direction: column;
    width: 90%;
  }

  ${({ inset }) =>
    inset &&
    css`
      padding: 36px 32px;
      margin-bottom: 24px;
      box-shadow: 0 0 10px rgba(168, 168, 168, 0.3) inset;
      background-color: white;
    `}
`;
const Column = styled.div`
  width: 670px;
  &:not(:last-child) {
    margin-right: 24px;
  }

  @media (max-width: 1350px) {
    width: 100%;
    margin-right: 0px;
    &:not(:last-child) {
      margin-right: 0;
    }
  }
`;
const Title = styled.h2`
  margin-left: 32px;
  margin-bottom: 14px;
  font-weight: bold;
  font-size: 24px;
  line-height: 47px;
  color: #03589c;
`;

function OrderDetailsDesktop({
  orderId,
  orderDetails,
  registerDetails,
  logoDesignServiceDetails,
  classes,
  productsFiles,
  hasSearch,
  hasMonitoring,
  individual,
  coOwners,
  organization,
  notes,
  assessments,
}) {
  return (
    <>
      <Row>
        <Column>
          <Title>Order Details</Title>
          <TrademarkRegisterDetails registerDetails={registerDetails} />
        </Column>
        <Column>
          {logoDesignServiceDetails ? (
            <>
              <Title>Logo Designs</Title>
              <Documents
                orderId={orderId}
                files={[...productsFiles]}
                emptyMessage="No Logo Designs Uploaded Yet."
                actions="LOGO_DESIGN_SERVICE"
              />
            </>
          ) : (
            <>
              <Title>Documents</Title>
              <Documents
                orderId={orderId}
                files={[...orderDetails.files, ...productsFiles]}
                assessments={assessments}
              />
            </>
          )}

          <Title>Order Status</Title>
          <OrderStatus
            orderId={orderId}
            specimen={!!registerDetails}
            search={hasSearch}
            monitoring={hasMonitoring}
            notes={notes}
          />
        </Column>
      </Row>
      <Row>{!!classes && <TrademarkClassifications classes={classes} />}</Row>
      <Row>
        {!!individual && <TrademarkOwners coOwners={coOwners} individual={individual} organization={organization} />}
      </Row>
    </>
  );
}

OrderDetailsDesktop.propTypes = {
  orderId: PropTypes.string,
  orderDetails: PropTypes.object,
  registerDetails: PropTypes.object,
  logoDesignServiceDetails: PropTypes.object,
  hasSearch: PropTypes.bool,
  hasMonitoring: PropTypes.bool,
  individual: PropTypes.object,
  organization: PropTypes.object,
  assessments: PropTypes.object,
  classes: PropTypes.arrayOf(PropTypes.object),
  coOwners: PropTypes.arrayOf(PropTypes.object),
  productsFiles: PropTypes.arrayOf(PropTypes.object),
  notes: PropTypes.arrayOf(PropTypes.object),
};

export default OrderDetailsDesktop;
